// extracted by mini-css-extract-plugin
module.exports = {"trigger":"_2jD-XO_tViXrF1NjGIpcMb","logo":"oGutGTXwqyoxQjAAUNsye"};